<template>
  <Modal
    v-model="_value"
    width="550"
    title="装配SIM卡"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content" ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Form autoComplete="on" class="card-box login-form">
      <Form-item label="SIM卡号">
        <Select
          v-model="selectSimInfos"
          multiple
          filterable
          remote
          :remote-method="searchSimInfo"
          :loading="searchSimInfoLoading">
          <Option v-for="(option, index) in searchSimInfoList" :value="option.id" :key="option.id">{{option.simNum}}</Option>
        </Select>
      </Form-item>
    </Form>
    <Row type="flex" justify="end">
      <Button type="primary" @click="onBindSimInfos">绑定</Button>
    </Row>
    <sim-info-detail-modal v-model="simInfoDetailModal" :initValue="simInfoDetailId"
                           @on-success="onSuccess"></sim-info-detail-modal>
  </Modal>
</template>
<script>

import SimInfoDetailModal from '@/view/im/components/sim-info-detail-modal'

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'AssembleSimModal',
  components: {
    SimInfoDetailModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      modify: false,
      simInfoDetailModal: false,
      simInfoDetailId: null,
      searchSimInfoList: [],
      searchSimInfoLoading: false,
      selectSimInfos: [],
      simStateOptions: [
        { label: '未安装', value: 0 },
        { label: '已安装', value: 1 },
        { label: '停用', value: 2 }
      ],
      simOperationOptions: [
        { label: '中国移动', value: 1 },
        { label: '中国联通', value: 2 },
        { label: '中国电信', value: 3 },
        { label: '珠海移动专网', value: 4 },
        { label: '中国移动-东莞中智', value: 5 },
        { label: '中国移动-佛山交协', value: 6 },
        { label: '中国电信-中山邦悦', value: 7 },
        { label: '中国移动-河北九宸', value: 8 },
        { label: '中国移动-中山邦悦', value: 9 },
        { label: '中国联通-中山邦悦', value: 10 },
        { label: '中国移动-深圳晓聪', value: 11 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 80
        },
        {
          title: 'SIM卡号',
          key: 'simNum',
          ellipsis: 'true',
          minWidth: 160
        },
        {
          title: '运营商',
          key: 'operation',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            let operation = params.row.operation
            if (operation === 1) {
              return h('div', '中国移动')
            } else if (operation === 2) {
              return h('div', '中国联通')
            } else if (operation === 3) {
              return h('div', '中国电信')
            } else if (operation === 4) {
              return h('div', '珠海移动专网')
            } else if (operation === 5) {
              return h('div', '中国移动-东莞中智')
            } else if (operation === 6) {
              return h('div', '中国移动-佛山交协')
            } else if (operation === 7) {
              return h('div', '中国电信-中山邦悦')
            } else if (operation === 8) {
              return h('div', '中国移动-河北九宸')
            } else if (operation === 9) {
              return h('div', '中国移动-中山邦悦')
            } else if (operation === 10) {
              return h('div', '中国联通-中山邦悦')
            } else if (operation === 11) {
              return h('div', '中国移动-深圳晓聪')
            }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.simInfoDetailId = params.row.id
                    this.simInfoDetailModal = true
                  }
                }
              }, '详细信息'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.$Modal.confirm({
                      title: '确认解绑SIM卡',
                      content: '<p>确认解绑SIM卡</p>',
                      onOk: () => {
                        store.dispatch('PositioningDeviceInfoServ_UnBindSimInfos', {
                          params: { id: this._initValue, simInfoIds: [params.row.id] }
                        }).then(() => {
                          this.$Message.success('修改成功')
                          this.updateTable()
                          this.$emit('on-success')
                        }).catch(err => {
                          this.$Message.error(err)
                          this.$emit('on-fail')
                        })
                      },
                      onCancel: () => {

                      }
                    })
                  }
                }
              }, '解绑')
            ])
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj',
      'PositioningDeviceInfoServ_BindSimInfos',
      'PositioningDeviceInfoServ_UnBindSimInfos',
      'SimInfoServ_GetAll'
    ]),
    onSuccess () {
      this.updateTable()
    },
    onBindSimInfos () {
      this.$Modal.confirm({
        title: '确认绑定SIM卡',
        content: '<p>确认绑定SIM卡</p>',
        onOk: () => {
          store.dispatch('PositioningDeviceInfoServ_BindSimInfos', {
            params: { id: this._initValue, simInfoIds: this.selectSimInfos }
          }).then(() => {
            this.$Message.success('修改成功')
            this.updateTable()
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    searchSimInfo (input) {
      this.searchSimInfoLoading = true
      if (!input || input.length <= 0) {
        this.searchSimInfoList = []
        this.searchSimInfoLoading = false
      } else {
        store.dispatch('SimInfoServ_SearchByName', {
          params: { name: input },
          urlparams: null
        }).then(() => {
          this.searchSimInfoList = store.getters.get_SimInfo_SearchByNameResult ? store.getters.get_SimInfo_SearchByNameResult : []
          this.searchSimInfoLoading = false
        }).catch(err => {
          this.searchSimInfoLoading = false
        })
      }
    },
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    updateTable () {
      this.listLoadding = true
      let queryParams = []
      let sortParam = null
      queryParams.push(genQueryParam('positioningDeviceInfoId', 'EQ', this._initValue))
      store.dispatch('SimInfoServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams,
          keyword: null,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        let positioningDeviceInfoId = this._initValue
        if (positioningDeviceInfoId) {
          this.searchSimInfoList = []
          this.selectSimInfos = []
          this.listLoadding = true
          let queryParams = []
          let sortParam = null
          queryParams.push(genQueryParam('positioningDeviceInfoId', 'EQ', positioningDeviceInfoId))
          store.dispatch('SimInfoServ_GetAll', {
            params: null,
            urlparams: {
              q: queryParams,
              keyword: null,
              sort: sortParam
            }
          }).then(() => {
            this.listLoadding = false
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_SimInfo_GetAllResult) {
        return store.getters.get_SimInfo_GetAllResult
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
